import { useState } from 'react'
import { apiGet, apiPut } from 'tennders-stracture/libs/api'
import useCompaniesStore from 'tennders-company/list/store/useCompaniesStore'
import useQueryAttributes from 'tennders-common/form/hooks/useQueryAttributes'

const useCompanyDirectoryCompanies = () => {
  const [companies, loading, setLoading, setCompanies] = useCompaniesStore((state) => [
    state.companies, state.loadingCompanies, state.setLoading, state.setCompanies
  ])

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 500,
    totalItem: 0,
    totalPage: 0
  })
  const attributes = useQueryAttributes()

  const fetchCompanies = async (params = {}) => {
    setLoading(true)
    const url = '/companies'
    const form = {
      params: {
        ...params,
        onlyParents: true,
        attributes: attributes.companyDirectoryQuery
      }
    }
    const response = await apiGet(url, form)
    setCompanies(response?.items || [])
    setPagination(response.meta?.pagination)
    setLoading(false)

    return response
  }

  const saveCompany = async (id, form) => apiPut(`companies/${id}`, form)
  return {
    fetchCompanies,
    companies,
    saveCompany,
    loading,
    pagination
  }
}

export default useCompanyDirectoryCompanies
